import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { useRoute } from '@nuxtjs/composition-api'
import {
  ConceptKind,
  ConceptStatus,
  useAddConceptMutation,
  useGetImpactGoalQuery,
  useGetUserQuery,
  useUpdateConceptMutation,
  useUpsertImpactSolutionMutation,
  type ConceptType,
  type ImpactSolutionType,
} from '~/types/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'SolutionConceptInput',
  props: {
    disabled: { type: Boolean, default: false },
    impactSolutionData: { default: undefined }
  },
  setup(__props: any) {

const props = __props as { disabled: boolean, impactSolutionData: ImpactSolutionType };



const route = useRoute()
const ventureId = computed(() => route.params.venture as string)
const impactSolution = computed(() => props.impactSolutionData as ImpactSolutionType)

const { mutate: updateConceptMutation } = useUpdateConceptMutation()
const { refetch } = useGetImpactGoalQuery({
  ventureId: ventureId.value,
})
const { mutate: upsertImpactSolutionMutation, onDone } = useUpsertImpactSolutionMutation()
onDone(() => {
  refetch()
})

const { mutate: addConcept } = useAddConceptMutation()
const { result } = useGetUserQuery()
const email = computed(() => result?.value?.getUser?.email ?? '')

const impactSolutionLabel = computed(() => impactSolution.value?.concept?.label ?? '')
const conceptId = computed(() => impactSolution.value?.concept?.id ?? null)

const triggerAddConcept = async (label: string) => {
  const input = {
    label,
    status: ConceptStatus.Proposed,
    kind: ConceptKind.Company,
    createdBy: email.value,
    sourceUrl: '',
    citation: '',
  }
  const conceptResponse = await addConcept({ input })
  return conceptResponse?.data?.addConcept as ConceptType
}

function upsertImpactSolution(fields: Record<string, unknown>) {
  if (props.disabled || !impactSolution.value?.id) return
  upsertImpactSolutionMutation({
    input: {
      id: impactSolution.value.id,
      impactId: impactSolution.value.impactId,
      ventureId: ventureId.value,
      ...fields,
    },
  })
}

async function handleConceptInput(val: string) {
  if (props.disabled) return
  const currentConceptId = conceptId.value
  if (currentConceptId === null) {
    const concept = await triggerAddConcept(val)
    const newConceptId = concept?.id || null
    upsertImpactSolution({ conceptId: newConceptId })
  } else {
    updateConceptMutation({
      input: {
        id: currentConceptId,
        label: val,
      },
    })
  }
}

return { __sfc: true,props, route, ventureId, impactSolution, updateConceptMutation, refetch, upsertImpactSolutionMutation, onDone, addConcept, result, email, impactSolutionLabel, conceptId, triggerAddConcept, upsertImpactSolution, handleConceptInput }
}

})